// src/components/TopHeader/TopHeader.js
import React from "react";
import "./TopHeader.css";

const TopHeader = () => {
  return (
    <div className="top-header">
      <div className="container">
        <div className="top-header-content">
          <div className="top-header-section">
            <span className="icon">
              <i className="fas fa-map-marked-alt"></i>
            </span>
            <div className="header-text">
              <span className="highlight">Free Call</span> +91 9067 161 025
              <div className="sub-text">Call Us Now 24/7 Customer Support</div>
            </div>
          </div>

          <div className="top-header-section">
            <span className="icon">
              <i className="fas fa-paper-plane"></i>
            </span>
            <div className="header-text">
              <span className="highlight">Our Location</span>
              <div className="sub-text">
                Sinhagad Road, Near Plaza, Pune - 411011
              </div>
            </div>
          </div>

          <div className="top-header-section social-section">
            <span className="icon">
              <i className="fas fa-th"></i>
            </span>
            <div className="header-text">
              <span className="highlight">Connect with us</span>
              <div className="sub-text">
                <a href="#">FACEBOOK</a>
                <a href="#">TWITTER</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
